// extracted by mini-css-extract-plugin
export var background = "image-gallery-module--background--49ad4";
export var caption = "image-gallery-module--caption--95732";
export var download = "image-gallery-module--download--36905";
export var gallery = "image-gallery-module--gallery--603e3";
export var galleryImage = "image-gallery-module--galleryImage--62836";
export var modal = "image-gallery-module--modal--7a6a4";
export var wrapper = "image-gallery-module--wrapper--886e3";
export var zoom = "image-gallery-module--zoom--15c11";